import { api, ReactQueryOptions, RouterInputs } from '@api';
import { staleTimeIndex } from '@specs/constants';
type optionsType = ReactQueryOptions['ToyManager']['getShopifyList'];
type inputType = RouterInputs['ToyManager']['getShopifyList'];
export const useGetShopifyList = (input: inputType, options?: optionsType) => api.ToyManager.getShopifyList.useQuery(input, {
  ...options,
  queryKey: ['ToyManager.getShopifyList', input],
  staleTime: 10 * 60 * 1000 * staleTimeIndex // 10 mins
});